import {useCallback, useEffect, useLayoutEffect, useState} from 'react';

export const useLoading = (url, startPreload) => {
    const available = Boolean(url);
    const [loading, setLoading] = useState(available);

    useLayoutEffect(() => setLoading(available), [url, available]);

    const setLoaded = useCallback(
        event => {
            setLoading(false);
            startPreload(event);
        },
        [setLoading, startPreload],
    );

    return [loading, setLoaded];
};

const useAbortPreloading = (loading, abortPreload) => useEffect(
    () => {
        if (loading) {
            const timer = setTimeout(abortPreload, 1000);

            return () => clearTimeout(timer);
        }
    },
    [loading, abortPreload],
);

const useDelayedLoading = (url, isRequesting, isInteractive, startPreload, abortPreload) => {
    const [loading, setLoaded] = useLoading(url, startPreload);

    useAbortPreloading(loading, abortPreload);

    const isLoading = (loading || isRequesting) && isInteractive === false;
    const [ready, setReady] = useState(isLoading);

    useEffect(
        () => {
            const timer = setTimeout(
                () => setReady(isLoading),
                isLoading ? 0 : 100,
            );

            return () => clearTimeout(timer);
        },
        [isLoading],
    );

    return [ready, setLoaded];
};

export default useDelayedLoading;
